import { DataList, DataItem } from '@cad-arc';
import { HoldEventEventView } from '@mark43/cad-api';
import { observer } from 'mobx-react-lite';

export const EventSummary = observer(function EventSummary({
    event,
}: {
    event: HoldEventEventView;
}): React.ReactElement {
    return (
        <DataList>
            <DataItem dataKey="Location">{event.eventLocation}</DataItem>
            <DataItem dataKey="CFS">{event.cfsNumberAndText}</DataItem>
        </DataList>
    );
});
